import { Reveal } from "./Reveal";
import { SERVICES } from "./data";
import { ArrowUpRight } from "lucide-react";

const ServiceCard = ({ s, delay }) => {
  const Icon = s.icon;
  const go = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
  return (
    <Reveal delay={delay} className={s.span}>
      <button
        data-testid={`service-card-${s.id}`}
        onClick={go}
        aria-label={`${s.title} — request a quote`}
        className="group relative w-full text-left h-full min-h-[21rem] rounded-3xl overflow-hidden bg-white border border-brand-line shadow-[0_12px_36px_rgba(2,71,157,0.06)] hover:shadow-[0_20px_40px_rgba(2,71,157,0.12)] hover:-translate-y-1 transition-all duration-300"
      >
        <div className="relative h-44 overflow-hidden">
          <img src={s.img} alt={s.title} className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105" />
          <span className="absolute top-4 left-4 flex items-center gap-2 rounded-full bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-bold text-brand-blue">
            <Icon className="h-4 w-4 text-brand-green" strokeWidth={2} aria-hidden="true" /> {s.label}
          </span>
        </div>
        <div className="p-7 flex items-start justify-between gap-4">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-brand-ink">{s.title}</h3>
            <p className="mt-2 text-base text-brand-ink2 leading-relaxed">{s.desc}</p>
          </div>
          <span className="shrink-0 grid place-items-center h-10 w-10 rounded-full bg-brand-blue text-white transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" /></span>
        </div>
      </button>
    </Reveal>
  );
};

export const Services = () => (
  <section id="services" aria-labelledby="services-heading" className="py-16 md:py-24 bg-brand-cream">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-sm font-bold uppercase tracking-wide text-brand-accentink">What we clean</span>
            <h2 id="services-heading" className="mt-3 font-heading font-extrabold tracking-tight text-3xl md:text-4xl text-brand-blue">Cleaning for every corner of your life</h2>
          </div>
          <p className="max-w-sm text-brand-ink2 leading-relaxed">Tap any service to request a tailored quote — we bring the eco-friendly products and the care.</p>
        </div>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
        {SERVICES.map((s, i) => (<ServiceCard key={s.id} s={s} delay={0.05 * i} />))}
      </div>
    </div>
  </section>
);
